'use client';

import { createListCollection, Stack } from '@chakra-ui/react';

import {
	generateNumberSteps, generateNumberRanges, renderLabel,
} from '@/modules/authentication/utils';
import type { AnnualSalaryStep } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const AnnualSalary = () => {
	const expectedSalary = generateNumberSteps(100_000, 2_500_000, 50_000);
	const expectedSalaryCollection = createListCollection({
		items: expectedSalary.map(value => ({
			label: `${value.toLocaleString()}~`,
			value: value.toString(),
		})),
	});

	const salaryRanges = generateNumberRanges(100_000, 2_500_000, 50_000);
	const currentSalaryCollection = createListCollection({
		items: salaryRanges.map(range => ({
			label: renderLabel(range),
			value: `${range.start}|||${range.end}`,
		})),
	});

	return (
		<Stack gap="md">
			<Form.SelectInput<AnnualSalaryStep>
				collection={currentSalaryCollection}
				label="Current Salary"
				name="currentAnnualSalary"
			/>
			<Form.SelectInput<AnnualSalaryStep>
				collection={expectedSalaryCollection}
				label="Expected Salary"
				name="expectedAnnualSalary"
			/>
		</Stack>
	);
};
